module.exports = __webpack_public_path__ + "img/Icon_Manejo_de_Citas.b1105ab3.svg";